import {
    KeyboardTimePicker,
    TimePicker,
    TimePickerProps,
} from "@material-ui/pickers";
import { Field, useFormikContext } from "formik";
import { DateTime } from "luxon";
import React, { useMemo } from "react";
import { useFieldValueAndValidation } from "ui/componentes/Form/functions";

type ModifiedTimePickerProps = Omit<TimePickerProps, "value" | "onChange">;

interface TimeFieldFormikProps {
    fieldType?: "timePicker" | "keyboardTimePicker";
}

const TimeFieldFormik: React.FC<
    TimeFieldFormikProps & ModifiedTimePickerProps
> = ({ fieldType, ...props }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext<any>();

    const timePickerComponent = useMemo(() => {
        return fieldType === "timePicker" ? TimePicker : KeyboardTimePicker;
    }, [fieldType]);

    const timeFormat = useMemo(() => {
        if (props.format) {
            return props.format;
        }
        return "HH:mm";
    }, [props.format]);

    let timeValue: any = null;

    const { value, error, hasTouched } = useFieldValueAndValidation(props.name);
    const showError = !!error && hasTouched;

    if (value) {
        timeValue = DateTime.fromFormat(value, timeFormat);

        if (timeValue && timeValue["invalid"]) {
            timeValue = "";
        }
    }

    return (
        <Field
            autoOk
            cancelLabel="Cancelar"
            {...props}
            error={showError}
            helperText={showError ? error : props.helperText}
            onBlur={() => setFieldTouched(props.name || "", true)}
            onChange={(v) => {
                let fieldValue = "";
                if (v && !v["invalid"]) {
                    fieldValue = v.toFormat(timeFormat);
                }

                setFieldTouched(props.name || "", true);
                setFieldValue(props.name || "", fieldValue);
            }}
            value={timeValue}
            component={timePickerComponent}
        />
    );
};

export { TimeFieldFormik };
export default TimeFieldFormik;
